import classNames from 'classnames';
import React from 'react';
import { FormattedValueWithUnit } from '../../common/formatHelper';
import CounterLabel from '../../components/events/CounterLabel';
import LegendItem from '../../components/events/LegendItem';
import * as Icon from '../../components/icons';

export type EventIssueTiming = 'before' | 'during' | 'after';

type EventIssueProps = {
  timing: EventIssueTiming;
  issues: {
    title: string;
    value: string | FormattedValueWithUnit;
  }[];
};

const getTimingStyles = (timing: EventIssueTiming) => {
  switch (timing) {
    case 'before':
      return {
        bgColor: 'bg-barber-pole bg-barber-size/10 bg-alerts-warning/5 ',
        textColor: 'text-alerts-warning',
        counterType: 'issue' as const,
        icon: Icon.TriangleInfo,
      };
    case 'during':
      return {
        bgColor: 'bg-barber-pole bg-barber-size bg-alerts-error/10',
        textColor: 'text-alerts-error',
        counterType: 'issue' as const,
        icon: Icon.TriangleWarning,
      };
    case 'after':
      return {
        bgColor: 'bg-barber-pole bg-barber-size bg-alerts-success/10',
        textColor: 'text-alerts-success',
        counterType: 'issue' as const,
        icon: Icon.CircleInfo,
      };
  }
};

const formatValue = (value: string | FormattedValueWithUnit): string => {
  if (!value) return '';
  
  if (typeof value === 'string') {
    return value;
  }
  
  // Handle FormattedValueWithUnit
  if (typeof value === 'object' && value.fullString) {
    return value.fullString;
  }
  
  // Fallback
  return String(value);
};

export const EventIssue: React.FC<EventIssueProps> = ({ timing, issues }) => {
  if (issues.length === 0) return null;

  const styles = getTimingStyles(timing);

  return (
    <div data-component="EventIssue" className={classNames(styles.bgColor,'relative' ,'flex flex-col w-full')}>
      <CounterLabel
        counterType={"Warn"}
        counterSize="issue"
        IconItem={styles.icon}
      >
        {/* {issues.map((issue, index) => (
          <span key={index}>{formatValue(issue.value)}</span>
        ))} */}
      </CounterLabel>
      
      <LegendItem legendSize="Full" legendType={"Info"} />

     
      {issues.map((issue, index) => (
        <div
          data-component="EventIssueItem"
          key={index}
          className={classNames(
            'flex w-full flex-1 flex-col py-2 ltr:pl-12 rtl:pr-12',
            styles.textColor,
          )}
          >
              
          <span>{issue.title}</span>
          <span>{formatValue(issue.value)}</span>
        </div>
      ))}
    </div>
  );
};

export default EventIssue; 